<script setup>
import { defineProps, getCurrentInstance } from 'vue';

const props = defineProps({
  mode: {
    type: String,
    default: 'outdated' // 'outdated' или 'maintenance'
  }
});

// Наш метод доступа к i18n
const inst = getCurrentInstance();
const t = (key, opt) => {
  const method = inst.appContext.config.globalProperties.$t || inst.proxy?.$t;
  return method ? method(key, opt) : key;
};
</script>

<template>
  <div class="auth-page-wrapper py-5 d-flex justify-content-center align-items-center min-vh-100">
    <div class="auth-page-content overflow-hidden p-0">
      <BContainer>
        <BRow class="justify-content-center">
          <BCol xl="7" lg="8">
            <div class="text-center">
              <div class="mb-4">
                <img
                    src="@/assets/images/server-error.png"
                    alt="status img"
                    class="img-fluid mx-auto"
                    style="max-width: 400px;"
                >
              </div>

              <div class="mt-3">
                <h3 class="text-uppercase fw-bold text-danger">
                  {{ props.mode === 'maintenance' ? t('page_errors.maintenance.title') : t('page_errors.outdated.title') }}
                </h3>

                <p class="text-muted mb-4 fs-15">
                  <span v-if="props.mode === 'maintenance'">
                    {{ t('page_errors.maintenance.desc') }}
                  </span>
                  <span v-else v-html="t('page_errors.outdated.desc')"></span>
                </p>

                <div class="mt-4" v-if="props.mode === 'outdated'">
                  <a
                      href="https://axiondmc.com/"
                      target="_blank"
                      rel="noopener noreferrer"
                      class="btn btn-primary btn-label rounded-pill shadow-none"
                  >
                    <i class="ri-download-2-line label-icon align-middle fs-16 me-2"></i>
                    {{ t('page_errors.outdated.btn') }}
                  </a>
                </div>

                <div class="mt-4" v-else>
                  <div class="spinner-border text-primary" role="status">
                    <span class="visually-hidden">Loading...</span>
                  </div>
                  <p class="text-muted mt-2 small">{{ t('page_errors.maintenance.waiting') }}</p>
                </div>

                <div class="mt-5">
                  <p class="text-muted small">
                    {{ t('page_errors.copyright', { year: new Date().getFullYear() }) }}
                  </p>
                </div>
              </div>
            </div>
          </BCol>
        </BRow>
      </BContainer>
    </div>
  </div>
</template>

<style lang="scss" scoped>
/* Оставил только минимум: фон и легкую анимацию для кнопки */
.auth-page-wrapper {
  background-color: var(--vz-body-bg);
}

.label-icon {
  animation: bounce-small 2s infinite;
}

@keyframes bounce-small {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-2px); }
}
</style>